'use client';

import { ToastsProvider } from '@/utils/hooks/context/toast/useToastsContext';
import { useFeatureFlag } from '@/utils/hooks/featureFlag/useFeatureFlag';
import useCurrentSession from '@/utils/hooks/user/useCurrentSession';

import { DatepickerGlobalStoreProvider } from '@/utils/zustand/providers/datepicker-global-provider';

import Loader from '@/components/base/Loader';
import { SparksAgent } from '@/components/composite/SparksAgent';

export function GlobalWrapper({ children }: { children: React.ReactNode }) {
    const { isLoading } = useCurrentSession();
    const isAiAgentActive = useFeatureFlag('ai_agent_active');

    if (isLoading) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader className="h-6 w-6 text-icoBlue" />
            </div>
        );
    }

    return (
        <DatepickerGlobalStoreProvider>
            <ToastsProvider>
                <div className="flex h-full w-full">
                    {children}
                    {isAiAgentActive && <SparksAgent />}
                </div>
            </ToastsProvider>
        </DatepickerGlobalStoreProvider>
    );
}
